<template>
    <div class="video-edit-model">
        <TitleBaseBox :title="title" class="model-wrap" @close="close" @cancel="cancelClick" @confirm="confirmClick">
            <div class="model-content">
                <ItemPanel :text="editConfig.videoPlatform">
                    <IconInput
                        class="model-input"
                        :initValue="platformTitle"
                        @inputChange="platformTitleChange"
                        :placeholder="editConfig.namePlaceholder"
                    />
                </ItemPanel>
                <ItemPanel :text="editConfig.videoName" :isRequired="true">
                    <IconInput class="model-input" :initValue="videoName" @inputChange="nameChange" :placeholder="editConfig.namePlaceholder" />
                </ItemPanel>
                <ItemPanel :text="editConfig.videoTag" :isRequired="true">
                    <TagSelect
                        class="model-tag-select"
                        type="video"
                        :placeholder="editConfig.tagPlaceholder"
                        :selected="videoTag"
                        @clickSelect="selectHandler"
                    ></TagSelect>
                </ItemPanel>
                <ItemPanel :text="editConfig.videoLang" :isRequired="true">
                    <LangSelect :value="initLang" class="lang-select" @change="langChange"></LangSelect>
                </ItemPanel>
                <ItemPanel :text="editConfig.videoLabel">
                    <IconInput class="model-input" :initValue="videoLabel" @inputChange="videoLabelChange" :placeholder="editConfig.labelHolder" />
                </ItemPanel>
                <ItemPanel :text="editConfig.playNumber">
                    <IconInput
                        class="model-input"
                        :initValue="playNumber"
                        @inputChange="playNumberChange"
                        :placeholder="editConfig.playNumberHolder"
                    />
                </ItemPanel>
                <ItemPanel :text="editConfig.likeNumber">
                    <IconInput
                        class="model-input"
                        :initValue="likeNumber"
                        @inputChange="likeNumberChange"
                        :placeholder="editConfig.likeNumberHolder"
                    />
                </ItemPanel>
                <ItemPanel :text="editConfig.showDate">
                    <el-date-picker
                        v-model="showDate"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        class="date-pick"
                        :placeholder="editConfig.showDateHolde"
                    >
                    </el-date-picker>
                </ItemPanel>
                <ItemPanel :text="editConfig.videoUrl" :isRequired="true">
                    <IconInput class="model-input" :initValue="videoUrl" @inputChange="urlChange" :placeholder="editConfig.urlPlaceholder" />
                </ItemPanel>
                <ItemPanel :text="editConfig.duration" :isRequired="true">
                    <IconInput class="model-input" :initValue="duration" @inputChange="durationChange" :placeholder="editConfig.durationLabel" />
                </ItemPanel>
                <ItemPanel :text="editConfig.videoSize">
                    <IconInput class="model-input" :initValue="videoSize" @inputChange="sizeChange" :placeholder="editConfig.sizeLabel" />
                </ItemPanel>
                <ItemPanel :text="editConfig.videoId" :isRequired="true">
                    <IconInput class="model-input" :initValue="videoId" @inputChange="videoIdChange" :placeholder="editConfig.videoIdLabel" />
                </ItemPanel>
                <ItemPanel :text="editConfig.videoCover" :isRequired="true">
                    <AddRefCoverPanel
                        class="image-upload-vedio"
                        :no-cover-icon="editConfig.noCoverIcon"
                        :image-url="cardImage"
                        :operate-icons="editConfig.operateIcons"
                        :view-icon="editConfig.viewIcon"
                        :ishorizontal="true"
                        :needClip="true"
                        :aspectRatio="16 / 9"
                        @change="cardImageChange"
                    />
                </ItemPanel>
                <div class="creator-info" v-if="isEditStatus">
                    <div>
                        <p>{{ $t("zhiji.common.creator") }}：{{ this.data.videoData.creator }}</p>
                        <p>{{ $t("zhiji.materialLibrary.updater") }}：{{ this.data.videoData.editor }}</p>
                    </div>
                    <div>
                        <p>{{ $t("zhiji.common.createTime") }}：{{ this.data.videoData.createTime }}</p>
                        <p>{{ $t("zhiji.materialLibrary.updateTime") }}：{{ this.data.videoData.updateTime }}</p>
                    </div>
                    <div>
                        <p>{{ $t("zhiji.materialLibrary.type") }}：{{ this.data.videoData.sourceType | conversionType }}</p>
                    </div>
                    <div>
                        <p>{{ $t("zhiji.materialLibrary.reading") }}：{{ this.data.videoData.amount }}</p>
                    </div>
                </div>
            </div>
        </TitleBaseBox>
    </div>
</template>

<script>
import TitleBaseBox from "@/views/zhiji/bComponents/TitleBaseBox";
import IconInput from "@/views/zhiji/bComponents/inputs/IconInput";
import ItemPanel from "@/views/zhiji/components/materialLibrary/ItemPanel";
import TagSelect from "@/views/zhiji/components/materialLibrary/TagSelect";
import LangSelect from "@/components/langSelect";
import AddRefCoverPanel from '@/views/zhiji/components/coverPanel/AddRefCoverPanel.vue';
import { videoEditConfig, videoChannel } from "@/views/zhiji/components/materialLibrary/materialLibraryConfig.js";
import i18n from "@/i18n";

export default {
    name: "VideoEditModel",
    props: ["data"],
    components: {
        TitleBaseBox,
        ItemPanel,
        IconInput,
        TagSelect,
        LangSelect,
        AddRefCoverPanel
    },
    data() {
        const defaultLang = this.$store.state.zhiji.gameState.defaultLang || "";
        return {
            videoTag: this.data.videoData.tagIds || "",
            videoName: this.data.videoData.title || "",
            platformTitle: this.data.videoData.platformTitle || "",
            videoUrl: this.data.videoData.videoUrl || "",
            cardImage: this.data.videoData.url || "",
            duration: this.data.videoData.duration || "",
            videoSize: this.data.videoData.videoSize || "",
            videoId: this.data.videoData.videoId || "",
            resizeType: 0,
            isEditStatus: this.data.type == "add" ? false : true,
            initLang: this.data.videoData.lang || defaultLang,
            videoLabel: this.data.videoData.videoLabel || "",
            playNumber: this.data.videoData.playNumber || "",
            likeNumber: this.data.videoData.likeNumber || "",
            showDate: this.data.videoData.showDate || ""
        };
    },
    computed: {
        editConfig() {
            return videoEditConfig();
        },
        title() {
            return this.data.type == "add" ? this.$t("zhiji.materialLibrary.addVideo") : this.$t("zhiji.materialLibrary.editVideo");
        }
    },
    filters: {
        conversionType(val) {
            let types = {
                0: "VLink"
            };
            return types[val];
        }
    },
    methods: {
        selectHandler(data) {
            this.videoTag = data;
        },
        nameChange(newVal) {
            this.videoName = newVal;
        },
        platformTitleChange(newVal) {
            this.platformTitle = newVal;
        },
        langChange(newVal) {
            this.initLang = newVal;
        },
        urlChange(newVal) {
            this.videoUrl = newVal;
            // 根据URL填充videoId
            let matchVideoId = newVal.match(/v=([^&]+)/);
            matchVideoId !== null ? (this.videoId = matchVideoId[1]) : "";
        },
        durationChange(newVal) {
            this.duration = newVal;
        },
        sizeChange(newVal) {
            this.videoSize = newVal;
        },
        videoIdChange(newVal) {
            this.videoId = newVal;
        },
        videoLabelChange(newVal) {
            this.videoLabel = newVal;
        },
        playNumberChange(newVal) {
            this.playNumber = newVal;
        },
        likeNumberChange(newVal) {
            this.likeNumber = newVal;
        },
        cardImageChange({ value }) {
            this.cardImage = value;
        },
        close() {
            this.$emit("closeModal");
        },
        cancelClick() {
            !this.data.childModel && this.close();
        },
        confirmClick() {
            let checkedData = {
                videoName: this.videoName,
                cardImage: this.cardImage,
                videoTag: this.videoTag,
                videoUrl: this.videoUrl,
                videoId: this.videoId,
                duration: this.duration
            };
            if (checkVlinkVideoData(checkedData)) {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "error",
                        message: checkVlinkVideoData(checkedData)
                    }
                });
            } else {
                this.saveVideoData();
            }
        },
        saveVideoData() {
            let handler = {
                add: this.addNewVideo,
                edit: this.editVideo
            };

            handler[this.data.type].call(null);
        },
        addNewVideo() {
            this.zhiji
                .requestByServiceName("addOneVLinkVideo", {
                    platformTitle: this.platformTitle,
                    videoName: this.videoName,
                    cardImage: this.cardImage,
                    videoTag: this.videoTag,
                    videoUrl: this.videoUrl,
                    sourceType: videoChannel.default,
                    videoId: this.videoId,
                    videoSize: this.videoSize,
                    duration: this.duration,
                    lang: this.initLang,
                    videoLabel: this.videoLabel,
                    playNumber: this.playNumber,
                    likeNumber: this.likeNumber,
                    showDate: this.showDate
                })
                .then(result => {
                    if (result.errCode) {
                        this.successTips(result.errMessage);
                        return;
                    }
                    this.data.confirm && this.data.confirm(result);
                    this.updateVideoList();
                    this.close();
                });
        },
        editVideo() {
            this.zhiji
                .requestByServiceName("updateVLinkVideo", {
                    ...this.data.videoData,
                    platformTitle: this.platformTitle,
                    videoName: this.videoName,
                    cardImage: this.cardImage,
                    videoTag: this.videoTag,
                    videoUrl: this.videoUrl,
                    videoId: this.videoId,
                    videoSize: this.videoSize,
                    duration: this.duration,
                    lang: this.initLang,
                    videoLabel: this.videoLabel,
                    playNumber: this.playNumber,
                    likeNumber: this.likeNumber,
                    showDate: this.showDate
                })
                .then(result => {
                    if (result.errCode) {
                        this.successTips(result.errMessage);
                        return;
                    }
                    this.data.confirm && this.data.confirm(result);
                    this.updateVideoList();
                    this.close();
                });
        },
        successTips(tipText) {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: tipText,
                    cancel: () => {},
                    confirm: () => {}
                }
            });
        },
        updateVideoList() {
            this.$store.dispatch("zhiji/queryVideoList", {});
        }
    }
};

// 校验视频编辑参数
function checkVlinkVideoData(data) {
    if (!data.videoName) {
        return i18n.t("zhiji.materialLibrary.videoNameRequired");
    }

    if (!data.videoTag) {
        return i18n.t("zhiji.materialLibrary.videoTagRequired");
    }

    if (!data.videoUrl) {
        return i18n.t("zhiji.materialLibrary.videoLinkRequired");
    }

    if (!data.videoId) {
        return i18n.t("zhiji.materialLibrary.videoIdLabel");
    }

    if (!data.cardImage) {
        return i18n.t("zhiji.materialLibrary.videoCoverRequired");
    }

    if (!data.duration) {
        return i18n.t("zhiji.materialLibrary.durationRequired");
    }
}
</script>

<style lang="less">
.video-edit-model {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(65, 71, 94, 0.4);
    display: flex;
    justify-content: center;
    align-items: center;
    .model-wrap {
        .model-content {
            width: 860px;
            padding: 4px 4px 0 4px;
            font-size: 12px;
            box-sizing: border-box;
            .model-input {
                width: 600px;
                height: 32px;
                background: #ffffff;
                border: 0;
                & > input {
                    border-color: #d8e4f0;
                    border-radius: 4px;
                }
                & > input:focus {
                    border-color: #2088f3;
                }
            }
            .model-tag-select {
                width: 600px;
            }
            .lang-select {
                width: 600px;
            }
            .image-upload-vedio {
                width: 180px;
                height: 107px;
                margin-right: 4px;
                background: #fafbfd;
                border: 1px solid #d8e4f0;
                border-radius: 4px;
            }
            .creator-info {
                width: 812px;
                margin-top: 16px;
                font-size: 12px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
        }
        .buttons {
            padding: 20px !important;
            background: #fafbfd;
            border-top: 1px solid #d8e4f0;
        }
    }

    .date-pick {
        border: 1px solid #d8e4f0;
        border-radius: 4px;
    }
}
</style>
